import { render, staticRenderFns } from "./giveOrder.vue?vue&type=template&id=0257772f&"
import script from "./giveOrder.vue?vue&type=script&lang=js&"
export * from "./giveOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports